import * as React from "react";

import { useTypedSelector } from "../../../Common/UseTypedSelector";

import { createHocDisplayName } from "./TypingUtils";

export interface WithDeferredInitInjectableProps {
    childrenCount: number;
    deferredInit?: boolean;
    onAddInstance: () => void;
}

export function withDeferredInit<P>(
    Component: React.ComponentType<P>
): React.ComponentClass<P & WithDeferredInitInjectableProps>;
export function withDeferredInit<P extends WithDeferredInitInjectableProps>(
    WrappedComponent: React.ComponentType<P>
): React.ComponentType<P> {
    function WithDeferredInit(props: P): JSX.Element {
        const isFormReloading = useTypedSelector(state => state.formVisualState.isFormReloading);

        const checkInstanceIsLoaded = () => {
            if (!isFormReloading && props.deferredInit && props.childrenCount === 0) {
                props.onAddInstance();
            }
        };

        React.useEffect(checkInstanceIsLoaded, [props.deferredInit, props.childrenCount, isFormReloading]);

        return <WrappedComponent {...props} />;
    }
    WithDeferredInit.displayName = createHocDisplayName(WrappedComponent, "DeferredInit");
    return WithDeferredInit;
}
